const localizedCountries = {
  af: 'Afeganistão',
  za: 'África do Sul',
  ax: 'Åland, Ilhas',
  al: 'Albânia',
  de: 'Alemanha',
  ad: 'Andorra',
  ao: 'Angola',
  ai: 'Anguilla',
  aq: 'Antárctida',
  ag: 'Antígua e Barbuda',
  sa: 'Arábia Saudita',
  dz: 'Argélia',
  ar: 'Argentina',
  am: 'Armênia',
  aw: 'Aruba',
  au: 'Austrália',
  at: 'Áustria',
  az: 'Azerbaijão',
  bs: 'Bahamas',
  bh: 'Bahrain',
  bd: 'Bangladesh',
  bb: 'Barbados',
  be: 'Bélgica',
  bz: 'Belize',
  bj: 'Benim',
  bm: 'Bermudas',
  by: 'Bielorrússia',
  bo: 'Bolívia',
  ba: 'Bósnia e Herzegovina',
  bw: 'Botswana',
  br: 'Brasil',
  bn: 'Brunei',
  bg: 'Bulgária',
  bf: 'Burkina Faso',
  bi: 'Burundi',
  bt: 'Butão',
  cv: 'Cabo Verde',
  cm: 'Camarões',
  kh: 'Cambodja',
  ca: 'Canadá',
  ky: 'Cayman, Ilhas',
  kz: 'Cazaquistão',
  cf: 'Centro-Africana, República',
  td: 'Chade',
  cz: 'Checa, República',
  cl: 'Chile',
  cn: 'China',
  cy: 'Chipre',
  cx: 'Christmas, Ilha',
  cc: 'Cocos, Ilhas',
  co: 'Colômbia',
  km: 'Comores',
  cd: 'Congo, (antigo Zaire)',
  cg: 'Congo, República do',
  ck: 'Cook, Ilhas',
  kr: 'Coréia do Sul',
  kp: 'Coréia do Norte',
  ci: 'Costa do Marfim',
  cr: 'Costa Rica',
  hr: 'Croácia',
  cu: 'Cuba',
  dk: 'Dinamarca',
  dj: 'Djibouti',
  dm: 'Dominica',
  do: 'Dominicana, República',
  eg: 'Egito',
  sv: 'El Salvador',
  ae: 'Emirados Árabes Unidos',
  ec: 'Equador',
  er: 'Eritreia',
  sk: 'Eslováquia',
  si: 'Eslovênia',
  es: 'Espanha',
  us: 'Estados Unidos',
  ee: 'Estónia',
  et: 'Etiópia',
  fo: 'Feroé, Ilhas',
  fj: 'Fiji',
  ph: 'Filipinas',
  fi: 'Finlândia',
  fr: 'França',
  ga: 'Gabão',
  gm: 'Gâmbia',
  gh: 'Gana',
  ge: 'Geórgia',
  gs: 'Geórgia do Sul, Ilhas',
  gi: 'Gibraltar',
  gr: 'Grécia',
  gd: 'Grenada',
  gl: 'Groenlândia',
  gp: 'Guadalupe',
  gu: 'Guam',
  gt: 'Guatemala',
  gg: 'Guernsey',
  gy: 'Guiana',
  gf: 'Guiana Francesa',
  gq: 'Guiné Equatorial',
  gw: 'Guiné-Bissau',
  gn: 'Guiné-Conacri',
  ht: 'Haiti',
  // HM: 'Heard e Ilhas McDonald, Ilha',
  hn: 'Honduras',
  hk: 'Hong Kong',
  hu: 'Hungria',
  ye: 'Iémen',
  in: 'Índia',
  id: 'Indonésia',
  ir: 'Irã',
  iq: 'Iraque',
  ie: 'Irlanda',
  is: 'Islândia',
  il: 'Israel',
  it: 'Itália',
  jm: 'Jamaica',
  jp: 'Japão',
  je: 'Jersey',
  jo: 'Jordânia',
  ki: 'Kiribati',
  kw: 'Kuwait',
  la: 'Laos',
  ls: 'Lesoto',
  lv: 'Letônia',
  lb: 'Líbano',
  lr: 'Libéria',
  ly: 'Líbia',
  li: 'Liechtenstein',
  lt: 'Lituânia',
  lu: 'Luxemburgo',
  mo: 'Macau',
  mk: 'Macedônia, República da',
  mg: 'Madagáscar',
  my: 'Malásia',
  mw: 'Malawi',
  mv: 'Maldivas',
  ml: 'Mali',
  mt: 'Malta',
  fk: 'Malvinas, Ilhas (Falkland)',
  im: 'Man, Ilha de',
  mp: 'Marianas Setentrionais',
  ma: 'Marrocos',
  mh: 'Marshall, Ilhas',
  mq: 'Martinica',
  mu: 'Maurícia',
  mr: 'Mauritânia',
  yt: 'Mayotte',
  // um: 'Menores Distantes dos Estados Unidos',
  mx: 'México',
  // fm: 'Micronésia, Estados Federados da',
  mz: 'Moçambique',
  md: 'Moldávia',
  mc: 'Mônaco',
  mn: 'Mongólia',
  me: 'Montenegro',
  ms: 'Montserrat',
  mm: 'Myanmar (antiga Birmânia)',
  na: 'Namíbia',
  nr: 'Nauru',
  np: 'Nepal',
  ni: 'Nicarágua',
  ne: 'Níger',
  ng: 'Nigéria',
  nu: 'Niue',
  nf: 'Norfolk, Ilha',
  no: 'Noruega',
  nc: 'Nova Caledônia',
  nz: 'Nova Zelândia',
  om: 'Oman',
  nl: 'Países Baixos (Holanda)',
  pw: 'Palau',
  ps: 'Palestina',
  pa: 'Panamá',
  pg: 'Papua-Nova Guiné',
  pk: 'Paquistão',
  py: 'Paraguai',
  pe: 'Peru',
  pn: 'Pitcairn',
  pf: 'Polinésia Francesa',
  pl: 'Polônia',
  pr: 'Porto Rico',
  pt: 'Portugal',
  qa: 'Qatar',
  ke: 'Quênia',
  kg: 'Quirguistão',
  // gb: 'Reino Unido da Grã-Bretanha e Irlanda do Norte',
  re: 'Reunião',
  ro: 'Romênia',
  rw: 'Ruanda',
  ru: 'Rússia',
  eh: 'Saara Ocidental',
  pm: 'Saint Pierre et Miquelon',
  sb: 'Salomão, Ilhas',
  ws: 'Samoa (Samoa Ocidental)',
  as: 'Samoa Americana',
  sm: 'San Marino',
  sh: 'Santa Helena',
  lc: 'Santa Lúcia',
  // kn: 'São Cristóvão e Névis (Saint Kitts e Nevis)',
  st: 'São Tomé e Príncipe',
  vc: 'São Vicente e Granadinas',
  sn: 'Senegal',
  sl: 'Serra Leoa',
  rs: 'Sérvia',
  sc: 'Seychelles',
  sg: 'Singapura',
  sy: 'Síria',
  so: 'Somália',
  lk: 'Sri Lanka',
  sz: 'Suazilândia',
  sd: 'Sudão',
  ss: 'Sudão do Sul',
  se: 'Suécia',
  ch: 'Suíça',
  sr: 'Suriname',
  sj: 'Svalbard e Jan Mayen',
  th: 'Tailândia',
  tw: 'Taiwan',
  tj: 'Tajiquistão',
  tz: 'Tanzânia',
  // tf: 'Terras Austrais e Antárticas Francesas (TAAF)',
  // io: 'Território Britânico do Oceano Índico',
  tl: 'Timor-Leste',
  tg: 'Togo',
  to: 'Tonga',
  tk: 'Toquelau',
  tt: 'Trindade e Tobago',
  tn: 'Tunísia',
  tc: 'Turks e Caicos',
  tm: 'Turquemenistão',
  tr: 'Turquia',
  tv: 'Tuvalu',
  ua: 'Ucrânia',
  ug: 'Uganda',
  uy: 'Uruguai',
  uz: 'Usbequistão',
  vu: 'Vanuatu',
  va: 'Vaticano',
  ve: 'Venezuela',
  vn: 'Vietnam',
  vi: 'Virgens Americanas, Ilhas',
  vg: 'Virgens Britânicas, Ilhas',
  wf: 'Wallis e Futuna',
  zm: 'Zâmbia',
  zw: 'Zimbabwe',
};

export default localizedCountries;
